const baseStyle = {
  closeButton: {
    '--vui-dismiss-fg': 'var(--vui-action-brand-solid)',
  },
}

const defaultProps = {
  size: 'md',
}

const parts = ['container', 'body', 'cancelButton', 'closeButton', 'footer', 'header', 'icon', 'submitButton', 'title']

const sizes = {
  md: {
    container: {
      maxW: 520,
    },
  },
  lg: {
    container: {
      maxW: 640,
    },
  },
  fullWidth: {},
}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
